// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__+zHi7","link":"styles_link__5QZV8","table":"styles_table__LweC3","stateRow":"styles_stateRow__ffrhb"};